import { Drawer } from 'antd'
import type { DeliveryReconHistoryRow, DeliveryReconOverviewRow } from '../types'
import { Content, type ContentProps } from '@/components/_SiteWide/AuditHistory/UpdateHistoryDrawer'

type ViewHistoryDrawerProps = {
  open: boolean
  onClose: () => void
  selectedPairing: DeliveryReconOverviewRow | null
  setSelectedPairing: React.Dispatch<React.SetStateAction<DeliveryReconOverviewRow | null>>
  historyData: ContentProps['auditHistory']
  isHistoryFetching: boolean
}

export function ViewHistoryDrawer({
  open,
  onClose,
  selectedPairing,
  setSelectedPairing,
  historyData,
  isHistoryFetching,
}: ViewHistoryDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      afterOpenChange={(open) => {
        if (!open) setSelectedPairing(null)
      }}
      title={`Site ${selectedPairing?.store_number} Audit`}
      width={'30vw'}
    >
      <Content auditHistory={historyData} loading={isHistoryFetching} />
    </Drawer>
  )
}
